import React, {
  useState,
  useEffect,
  useRef
} from 'react';
import { useNavigate } from "react-router-dom";
import Cookies from 'js-cookie';
import './Subscription.css';

import { Footer } from "../../components/footer/footer";
import Googleadshorizontal from "../../components/google-AdSense/Googleadshorizontal";
import Navbarr from "../../components/header/Navbarr";
import ScrollButton from "../../components/scrollbutton/ScrollButton";
import Subheader from "../../components/subheader/Subheader";
import SubscribeButton from '../../components/subscribe/SubscribeButton';

import { Errormsg } from '../../components/tostifymsg/Errrormsg';
import { Succesmsg } from '../../components/tostifymsg/Succesmsg';
import { cancelSubscription, generateLinkSubscription, getSubscriptions } from '../../api/handleapi';
import { useSubscription } from '../../shared/hooks/useSubscription';

function Subscription() {
  const [plans, setPlans] = useState([]);
  const [subscription, setSubscription] = useState(null);
  const [disabledBtn, setDisabledBtn] = useState(false);
  const navigate = useNavigate();

  const descriptionPlans = {
    'prod_TFpqc9jJTMo4qt': {
      features: [
        'No Ads',
        'Comment on news and movies',
        'Weekly recap newletter',
        'Chat with friends and league members',
        'Ranked top movie in league'
      ]
    },
    'prod_TFq1SAMQreV6I5': {
      features: [
        'Everything in casual',
        'Movie discussion boards and forums',
        'Advanced filters',
        'Release calendar access'
      ]
    },
    'prod_TFq22tgYn9LJXg': {
      features: [
        'Everything in Casual and Fanatic',
        'Ask the Experts: tips & insider insights',
        'Name recognition on Cinephile page'
      ]
    },
    'prod_TFTiqMF21yeRdZ': {
      features: [
        'No Ads',
        'Comment on news and movies',
        'Weekly recap newletter',
        'Chat with friends and league members',
        'Ranked top movie in league'
      ]
    },
    'prod_TFTkCNeqRul4lM': {
      features: [
        'Everything in casual',
        'Movie discussion boards and forums',
        'Advanced filters',
        'Release calendar access'
      ]
    },
    'prod_TFThxHq964cYX7': {
      features: [
        'Everything in Casual and Fanatic',
        'Ask the Experts: tips & insider insights',
        'Name recognition on Cinephile page'
      ]
    }
  };

  const firebaseUserId = Cookies.get("firebaseuid");
  const userId = Cookies.get("id");

  const { subscriptionInfo, loading, error } = useSubscription(firebaseUserId);
  
  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const response = await getSubscriptions();

        const mapEntityPlans = response.data.map((plan) => {
          return {
            ...plan,
            featuresDescriptions: descriptionPlans[plan.id]?.features || []
          }
        }).sort((a, b) => a.prices[0].amount - b.prices[0].amount);

        setPlans(mapEntityPlans);
      } catch (error) {
        Errormsg("Failed to load subscription plans.");
      }
    }

    fetchPlans();
  }, []);

  useEffect(() => {
    const subscriptionData = localStorage.getItem('subscriptionInfo');

    if(subscriptionData) {
      setSubscription(JSON.parse(subscriptionData));
    }

    console.log('subscription', subscriptionData);
  }, []);

  const handlerSubscribe = async (priceId) => {
    try {
      setDisabledBtn(true);
      const response = await generateLinkSubscription({
        firebaseUserId: firebaseUserId,
        userId: userId,
        priceId: priceId
      });

      const { url } = response.data.data;

      if (url) {
        Succesmsg("Redirecting to subscription checkout...");
        setTimeout(() => {
          window.location.href = url;
          setDisabledBtn(false);
        }, 500);
      }
    } catch(error) {
      setDisabledBtn(false);
      Errormsg("Subscription failed. Please try again.");
      return;
    }
  }

  const handlerCancel = async (subscriptionId) => {
    try {
      const response = await cancelSubscription({
        subscriptionItemId: subscriptionId,
        userId: userId
      });

      navigate('/CancelSuccess');
    } catch(error) {
      Errormsg("Cancellation failed. Please try again.");
      return;
    }
  }

  return (<div>
    <Navbarr/>

    <div className="after-nav-dsubheader containers con_div">
      <Googleadshorizontal props="mt-2 mb-2 text-center"/>
      <Subheader />
      
      <div className='h-100 min-vh-100'>
        <h3 className='mt-4 text-white fw-bold text-center'>
          Subscribe
        </h3>

        <div className="d-flex gap-5 justify-content-center flex-wrap mt-3 mb-4">
          { !subscription && plans.map((plan) => (
            <SubscribeButton
              key={plan.id}
              id={plan.id}
              features={true}
              name={plan.name}
              price={(plan.prices[0].amount).toFixed(2)}
              handlerSubscribe={() => handlerSubscribe(plan.prices[0].id)}
              disabled={disabledBtn}
              featuresDescriptions={plan.featuresDescriptions}
            />
          ))}

          { subscription && 
            <div className='text-center'>
              <h4 className='text-white fw-bold mb-3'>You are already subscribed to a plan.</h4>

              <SubscribeButton
                key={subscription.id}
                id={subscription.id}
                features={true}
                featuresDescriptions={descriptionPlans[subscription.product.store_identifier]?.features || []}
                content={`
                  <div class="pb-4">
                    Your subscription is active until ${new Date(subscription.ends_at).toLocaleDateString()}. <br/>
                    
                    ${ subscription.store === 'app_store' ? '<a href="https://apps.apple.com/account/subscriptions" class="text-decoration-underline mb-5">Apple</a> to manage your subscription.' : '' }
                    ${ subscription.store === 'mac_app_store' ? '<a href="https://apps.apple.com/account/subscriptions" class="text-decoration-underline mb-5">Apple</a> to manage your subscription.' : '' }
                    ${ subscription.store === 'play_store' ? '<a href="https://play.google.com/store/account/subscriptions" class="text-decoration-underline mb-5">Google</a> to manage your subscription.' : '' }

                    ${ subscription.auto_renewal_status === 'will_not_renew' ? '<p class="pb-0 mb-0"><small>will not auto-renew.</small></p>' : '' }
                  </div>
                `}
                name={subscription.product.display_name}
                price={0}
                handlerCancel={subscription.store === 'stripe' && subscription.auto_renewal_status === 'will_renew' ? () => handlerCancel(subscription.store_subscription_identifier) : null}
              />
            </div>
          }
        </div>

        <div className="d-flex gap-5 justify-content-center flex-wrap mt-5 pb-5">
          { (subscription?.auto_renewal_status === 'will_not_renew' || subscription) &&
            <h4 className='text-white fw-bold text-center w-100'>
              Other Plans
            </h4>
          }

          {
            (subscription?.auto_renewal_status === 'will_not_renew' || subscription) && plans.map((plan) => {
              if(subscription && subscription.product.store_identifier === plan.id) {
                return null;
              }
              
              return (<SubscribeButton
                key={plan.id}
                id={plan.id}
                features={true}
                name={plan.name}
                price={(plan.prices[0].amount).toFixed(2)}
                handlerSubscribe={() => handlerSubscribe(plan.prices[0].id)}
                disabled={disabledBtn}
                featuresDescriptions={plan.featuresDescriptions}
              />)
            })
          }
        </div>

      </div>
    </div>

    <Footer />
    <ScrollButton />
  </div>);
}

export default Subscription;